<template>
  <div class="main-wrapper">
    <div>
      <!-- <layout-header2></layout-header2> -->
      <layout-header></layout-header>
      <breadcrumb50></breadcrumb50>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar></sidebar>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>

            <div class="col-md-7 col-lg-8 col-xl-9" v-if="!showspinner">
              <div class="row">
                <div class="col-md-12" id="encounter_container">
                  <h3 class="mb-4 mt-2">Reciepts</h3>
                  <div class="appointment-tab">
                    <div class="tab-content">
                      <!-- Receipt Data -->
                      <div class="tab-pane show active" id="today-appointments">
                        <div class="card card-table mb-0">
                          <div class="card-body">
                            <div class="table-responsive">
                              <table class="table table-hover table-center mb-0">
                                <thead>
                                  <tr>
                                    <th class="text-left">Receipt Number</th>
                                    <th class="text-left">Date</th>
                                    <th class="text-left">Patient Name</th>
                                    <th class="text-left">Amount</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, $index) in receipt_details" :key="item.id"
                                    v-show="setOpenPaginate($index)">
                                    <td class="text-left">
                                      <h2 class="table-avatar">
                                        <a href="javascript:void(0);" class="avatar avatar-sm mr-2" @click=""><img
                                            class="avatar-img rounded-circle" v-bind:src="item.image
                                              ? config.base_url_for_Image +
                                              item.image
                                              : loadImg(
                                                'Patient Profile.svg'
                                              )
                                              " alt="User Image" /></a>
                                        <a href="javascript:void(0);" @click="">{{ item.name }}</a>
                                        <!-- </router-link> -->
                                      </h2>
                                    </td>
                                    <td class="text-left">
                                      {{
                                        item.date ? formatDate(item.date) : "-"
                                      }}
                                    </td>
                                    <td class="text-left">
                                      {{ item.patient_full_name }}

                                    </td>
                                    <td class="text-left">{{ item.amount ? item.amount : "-" }}</td>
                                  </tr>
                                </tbody>
                              </table>
                              <h5 v-if="receipt_details.length === 0 && !showspinner
                                " class="No_data">
                                No Receipt Data Found
                              </h5>
                              <div id="pagination" v-if="receipt_details.length > 10">
                                <a href="#" v-for="page_index in open_paginate_total" :key="page_index.id" :class="open_current === page_index
                                  ? 'pagination-active'
                                  : ''
                                  " class="btn btn-default active-pagination"
                                  @click.prevent="updateOpenCurrent(page_index)">
                                  {{ page_index }}
                                </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- /recepit data -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
  </div>
</template>
  
<script>
import CommonApi from "@/services/CommonApi";
import config from "../../../services/CommonApi";
import { mapState } from "vuex";
const images = require.context("@/assets/img/patients");

export default {
  data() {
    return {
      config: config,
      receipt_details: [],
      showspinner: true,

      open_current: 1,
      open_paginate: 10,
      open_paginate_total: 0,

      closed_current: 1,
      closed_paginate: 10,
      closed_paginate_total: 0,
    };
  },
  mounted() {
    this.getReceiptDetails(),
      $(".progressresult").each(function () {
        const percentageToDegrees = (percentage) => {
          return (percentage / 100) * 360;
        };
        let value = $(this).attr("data-value");
        let left = $(this).find(".progress-left .progress-bar");
        let right = $(this).find(".progress-right .progress-bar");

        if (value > 0) {
          if (value <= 50) {
            right.css(
              "transform",
              "rotate(" + percentageToDegrees(value) + "deg)"
            );
          } else {
            right.css("transform", "rotate(180deg)");
            left.css(
              "transform",
              "rotate(" + percentageToDegrees(value - 50) + "deg)"
            );
          }
        }
      });
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      user_type: (state) => state.user.user_type,
    }),
  },
  methods: {
    formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  },
    setOpenPaginate(i) {
      if (this.open_current == 1) {
        return i < this.open_paginate;
      } else {
        return (
          i >= this.open_paginate * (this.open_current - 1) &&
          i < this.open_current * this.open_paginate
        );
      }
    },

    updateOpenCurrent(i) {
      this.open_current = i;
      document.getElementById("encounter_container").scrollIntoView();
    },

    setClosedPaginate(i) {
      if (this.closed_current == 1) {
        return i < this.closed_paginate;
      } else {
        return (
          i >= this.closed_paginate * (this.closed_current - 1) &&
          i < this.closed_current * this.closed_paginate
        );
      }
    },

    updateClosedCurrent(i) {
      this.closed_current = i;
      document.getElementById("encounter_container").scrollIntoView();
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },
    async getReceiptDetails() {
      const receiptId = this.$route.params.receiptId;
      await CommonApi.get_data(
        "sahaj.api.get_dr_opd_receipt_details",
        new URLSearchParams({ name: receiptId })
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.receipt_details = res.data;
          this.open_paginate_total = Math.ceil(
            this.receipt_details.length / this.open_paginate
          );
        }
      });
    },
  },
};
</script>
  


// WEBPACK FOOTER //
// src/components/kneexpert/doctor/ReceiptDetails.vue